import { render, staticRenderFns } from "./AdvButtonViewBuy.vue?vue&type=template&id=4e43c27e"
import script from "./AdvButtonViewBuy.vue?vue&type=script&lang=js"
export * from "./AdvButtonViewBuy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports